import { render, staticRenderFns } from "./BotSelect.vue?vue&type=template&id=47e96868&scoped=true&"
import script from "./BotSelect.vue?vue&type=script&lang=js&"
export * from "./BotSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e96868",
  null
  
)

export default component.exports